import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { addWeeks, addDays, format } from 'date-fns';
import frLocale from 'date-fns/locale/fr';
import React, { useState } from 'react';

import { diffWeeksDays } from './commons/utils';
import DetectionPage from './scenes/DetectionsPage';
import EchoPage from './scenes/EchoPage';
import InputsPage from './scenes/InputsPage';
import LimitsPage from './scenes/LimitsPage';
import VacationsPage from './scenes/VacationsPage';

import './App.css';

const App = () => {
    const dateFormat = 'dd LLL yyyy';
    const [main, setMain] = useState({
        theoretic: null,
        date: null,
        term: null,
        diff: { weeks: 0, days: 0 },
        today: new Date(),
    });
    const [echo, setEcho] = useState();
    const [limit, setLimit] = useState();
    const [vacation, setVacation] = useState();
    const [detection, setDetection] = useState();
    const isSmallScreen = window.screen.width < 1081;

    const changeDate = mainDates => {
        const { date, theoretic, term, today } = mainDates;
        const diff = date ? diffWeeksDays(today, date) : mainDates.diff;
        setMain({
            date,
            theoretic,
            term,
            today,
            diff,
        });
        if (!date) {
            setLimit(undefined);
            setVacation(undefined);
            setDetection(undefined);
            setEcho(undefined);
            return;
        }

        setEcho({
            echo1: {
                min: format(addWeeks(date, 11), dateFormat),
                max: format(addDays(addWeeks(date, 13), 6), dateFormat),
                best: format(addWeeks(date, 12), dateFormat),
            },
            echo2: {
                min: format(addWeeks(date, 20), dateFormat),
                max: format(addWeeks(date, 25), dateFormat),
                best: format(addWeeks(date, 22), dateFormat),
            },
            echo3: {
                min: format(addWeeks(date, 30), dateFormat),
                max: format(addWeeks(date, 35), dateFormat),
                best: format(addWeeks(date, 32), dateFormat),
            },
        });
        setLimit({
            ivg: format(addWeeks(date, 14), dateFormat),
            declar: format(addWeeks(date, 16), dateFormat),
        });
        setVacation({
            less2: {
                start: format(addWeeks(date, 35), dateFormat),
                end: format(addWeeks(date, 51), dateFormat),
            },
            more1: {
                start: format(addWeeks(date, 33), dateFormat),
                end: format(addWeeks(date, 59), dateFormat),
            },
            twins: {
                start: format(addWeeks(date, 29), dateFormat),
                end: format(addWeeks(date, 63), dateFormat),
            },
            triplet: {
                start: format(addWeeks(date, 17), dateFormat),
                end: format(addWeeks(date, 63), dateFormat),
            },
        });
        setDetection({
            trisomy: {
                first: {
                    min: format(addWeeks(date, 11), dateFormat),
                    max: format(addDays(addWeeks(date, 13), 6), dateFormat),
                },
                second: {
                    min: format(addWeeks(date, 14), dateFormat),
                    max: format(addWeeks(date, 18), dateFormat),
                },
            },
            Gly: {
                min: format(addWeeks(date, 24), dateFormat),
                max: format(addWeeks(date, 28), dateFormat),
            },
            strepto: {
                min: format(addWeeks(date, 34), dateFormat),
                max: format(addWeeks(date, 38), dateFormat),
            },
        }); // setMainDate(mainDates.term);
    };

    function getMain() {
        return (
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
                <InputsPage changeDate={changeDate} {...main} />
                {echo && (
                    <div className="data">
                        <EchoPage {...echo} />
                        <LimitsPage declar={limit.declar} ivg={limit.ivg} />
                        <VacationsPage {...vacation} />
                        <DetectionPage {...detection} />
                    </div>
                )}
            </LocalizationProvider>
        );
    }
    // eslint-disable-next-line sonarjs/no-all-duplicated-branches
    return <div className="layout">{isSmallScreen ? getMain() : getMain()}</div>;
};

export default App;
